import { Text, FormControl } from "@chakra-ui/react";
import { Select } from "antd";
import { minimumEventDurationOptions } from "../../constants/SendConfigConstants";
import { SEND_CONFIG_THEME } from "./theme";

interface MinimumEventDurationSelectProps {
  t: (key: React.Key) => string;
  value?: number;
  onChange: (value: number) => void;
}

/**
 * Select component for minimum event duration
 * Extracted for better maintainability and reusability
 */
export function MinimumEventDurationSelect({
  t,
  value,
  onChange,
}: MinimumEventDurationSelectProps) {
  const handleChange = (selectedValue: number) => {
    onChange(selectedValue);
  };

  const formatOptionLabel = (option: typeof minimumEventDurationOptions[0]) => {
    if (option.unit === "minutes") {
      return `${option.value} ${t("minutes")}`;
    }
    // option.unit === "hours"
    // Convert minutes to hours for display
    const hourValue = option.value / 60;
    // Use singular/plural translation based on value
    const hourLabel = hourValue === 1 ? t("hour") : t("hours");
    return `${hourValue} ${hourLabel}`;
  };

  // Build options with proper labels for display
  const selectOptions = minimumEventDurationOptions.map((option) => ({
    value: option.value,
    label: formatOptionLabel(option),
  }));

  return (
    <>
      <Text
        color={SEND_CONFIG_THEME.colors.textPrimary}
        fontSize={SEND_CONFIG_THEME.fontSize.title}
        fontWeight="medium"
      >
        {t("sendConfig.minimumEventDuration")}
      </Text>
      <FormControl isRequired>
        <Select
          placeholder={t("sendConfig.selectPlaceholder")}
          id="minimumEventDuration"
          dropdownStyle={{ zIndex: 2000 }}
          style={{
            width: "100%",
            height: "50px",
          }}
          value={value}
          onChange={handleChange}
          options={selectOptions}
        />
      </FormControl>
    </>
  );
}
